import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Checkbox, FormControl, InputLabel } from "@mui/material";
import { LinearProgress, TextField, Typography } from "@mui/material";
import { MenuItem, Select } from "@mui/material";
import { Box, Button, IconButton } from "@mui/material";
import { Form, Formik } from "formik";
import { RpcError } from "grpc-web";
import { useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { AuthContext, AuthContextInterface } from "../../contexts";
import { S3CredentialsContext, UserDetailsContext } from "../../contexts";
import { S3CredentialsContextInterface } from "../../contexts";
import { UserDetailsContextInterface } from "../../contexts";
import { UsernameSelectField } from "../../pages/MyTracks/styles";
import { styles, useStyles } from "../../pages/MyTracks/styles";
import { ContainerModal } from "../../pages/MyTracks/styles";
import { EmailInviteTextField } from "../../pages/MyTracks/styles";
import { AddVersionModalProps } from "../../pages/MyTracks/types";
import { AudioMetadata, FileState, TrackState } from "../../proto/api_pb";
import { GetTracksResponse, InviteTemplate, Track } from "../../proto/api_pb";
import { TrackFileTypeMap, Collaborator } from "../../proto/api_pb";
import { TrackFile, TrackFileType, User } from "../../proto/api_pb";
import { InvitedCollaborator } from "../../proto/api_pb";
import { InvitedCollaboratorState } from "../../proto/api_pb";
import { fetchTracks, postTrackFile } from "../../services/trackService";
import { sendInvites } from "../../services/trackService";
import { awaitableUploadToS3 } from "../../utils/S3Utils";
import { LightTooltip } from "../LightToolTip/LightToolTip";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Files from "react-files";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { determineSetBpm } from "../../utils/bpmUtil";
import Mixpanel from "../../utils/mixpanel";
import { CustomLinearProgress } from "../ProgressComponents/CustomLinearProgress";
import { emailRegex } from "../constants";
import { TRACK_VALIDATION_SCHEMA, fileTypes, newAddTrack } from "./types";
import { addTrackFileModalStyles } from "./styles";
import { APP_BACKGROUND_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";
import { SelectField } from "../../pages/ProfileSettings/types";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { SVG_ICON_COLOR } from "../../theme";
import { SessionSvg, StemVocalSvg, StemDrumSvg } from "../SVGIcons";
import { StemInstrumentSvg, StemBasslineSvg, LyricsSvg } from "../SVGIcons";
import { StemMelodySvg, ArtworkSvg, OtherSvg } from "../SVGIcons";
const ASSETS_URL = process.env.REACT_APP_ASSET_S3_BUCKET_URL!;
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface SvgMapInerface {
  [key: string]: JSX.Element;
}
const svgMap: SvgMapInerface = {
  Session: <SessionSvg color={SVG_ICON_COLOR} />,
  "Stem Vocal": <StemVocalSvg color={SVG_ICON_COLOR} />,
  "Stem Drum": <StemDrumSvg color={SVG_ICON_COLOR} />,
  "Stem Melody": <StemMelodySvg color={SVG_ICON_COLOR} />,
  "Stem Bassline": <StemBasslineSvg color={SVG_ICON_COLOR} />,
  "Stem Instrument": <StemInstrumentSvg color={SVG_ICON_COLOR} />,
  Lyrics: <LyricsSvg color={SVG_ICON_COLOR} />,
  Artwork: <ArtworkSvg color={SVG_ICON_COLOR} />,
  Other: <OtherSvg color={SVG_ICON_COLOR} />,
};

const AddTrackFileModal: React.FC<AddVersionModalProps> = ({
  open,
  handleClose,
  track,
  handleFileAdded,
  parentFolderId,
}) => {
  const classes = useStyles();
  const { getValidAccessToken } = useGetValidAccessToken();
  const [fileLabel, setfileLabel] = useState("");
  const [showTrackVersionTooltip, setShowTrackVersionTooltip] = useState(false);
  const { userId } = useContext<AuthContextInterface>(AuthContext);
  const [uploadedFile, setUploadedFile] = useState<any>(undefined);
  const [progress, setProgress] = useState(0);
  const [fileType, setFileType] = useState<
    TrackFileTypeMap[keyof TrackFileTypeMap]
  >(TrackFileType.TRACK_FILE_TYPE_UNSPECIFIED);
  const [isStem, setIsStem] = useState(false);
  const [bpmLoading, setBpmLoading] = useState(false);
  const [showBpmTooltip, setShowBpmTooltip] = useState(false);
  const [emailInvite, setEmailInvite] = useState("");
  const [emailInviteList, setEmailInviteList] = useState<string[]>([]);
  const [collaborators, setCollaborators] = useState<Array<Collaborator>>([]);
  const [collabVal, setCollabVal] = useState("");
  const [usersList, setUsersList] = useState<Array<User>>([]);
  const { allUsers, userName } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);
  const [showCollabTooltip, setShowCollabTooltip] = useState(false);
  const [addedCollabIds, setAddedCollabIds] = useState<string[]>([]);
  const [allTracksList, setAllTracksList] = useState<Track[]>([]);
  const [selectedTracksList, setSelectedTracksList] = useState<string[]>([]);
  const { awsAccessKeyId, awsSecretAccessKey, awsSessionToken } =
    useContext<S3CredentialsContextInterface>(S3CredentialsContext);

  const getAllTracks = useCallback(async () => {
    if (!track?.getId()) {
      const token = await getValidAccessToken();
      try {
        const response = (await fetchTracks(
          token,
          userId
        )) as GetTracksResponse;
        const filteredTracks = response
          .getTracksList()
          .map((track) => track.getTrack())
          .filter(
            (track): track is Track =>
              track?.getState() !== TrackState.TRACK_STATE_DELETED
          );
        setAllTracksList(filteredTracks);
      } catch (e) {
        const error = e as RpcError;
        console.log(error.message);
      }
    }
  }, [getValidAccessToken, track, userId]);

  useEffect(() => {
    if (userId !== "") {
      getAllTracks();
    }
  }, [userId, getValidAccessToken, getAllTracks]);

  const handleChangeFileType = (event: any) => {
    setFileType(event.target.value as TrackFileTypeMap[keyof TrackFileTypeMap]);
  };

  const handleProgress = (pNum: number) => {
    setProgress(pNum);
  };

  const handleshowBpmTooltip = () => {
    setShowBpmTooltip((prev) => !prev);
  };

  useEffect(() => {
    const userL = allUsers.filter((user) => user.getUsername() !== userName);

    setUsersList(userL);
  }, [allUsers, userName]);

  const handleAddFileToUpload = (
    newFiles: any[],
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined
    ) => void
  ) => {
    setUploadedFile(newFiles[0]);
    setFieldValue("fileUpload", newFiles[0]);
    if (newFiles[0].type.startsWith("image/")) {
      setFileType(TrackFileType.TRACK_FILE_TYPE_ARTWORK);
      setIsStem(false);
    } else if (
      newFiles[0].type.startsWith("audio/") ||
      newFiles[0].name.endsWith(".caf")
    ) {
      determineSetBpm(newFiles[0], setFieldValue, setBpmLoading);
      setIsStem(true);
    } else if (
      newFiles[0].name.endsWith(".abl") ||
      newFiles[0].name.endsWith(".ablbundle") ||
      newFiles[0].name.endsWith(".adg") ||
      newFiles[0].name.endsWith(".agr") ||
      newFiles[0].name.endsWith(".adv") ||
      newFiles[0].name.endsWith(".alc") ||
      newFiles[0].name.endsWith(".alp") ||
      newFiles[0].name.endsWith(".als") ||
      newFiles[0].name.endsWith(".ams") ||
      newFiles[0].name.endsWith(".amxd") ||
      newFiles[0].name.endsWith(".asd") ||
      newFiles[0].name.endsWith(".ask") ||
      newFiles[0].name.endsWith(".ptx") ||
      newFiles[0].name.endsWith(".logic") ||
      newFiles[0].name.endsWith(".logicx") ||
      newFiles[0].name.endsWith(".band") ||
      newFiles[0].name.endsWith(".band.zip") ||
      newFiles[0].name.endsWith(".aup3") ||
      newFiles[0].name.endsWith(".zip") ||
      newFiles[0].name.endsWith(".flp") ||
      newFiles[0].name.endsWith(".fst") ||
      newFiles[0].name.endsWith(".fsc") ||
      newFiles[0].name.endsWith(".fpr")
    ) {
      setFileType(TrackFileType.TRACK_FILE_TYPE_SESSION);
      setIsStem(false);
    } else {
      setFileType(TrackFileType.TRACK_FILE_TYPE_OTHER);
      setIsStem(false);
    }
  };

  const handleShowVersionTooltip = () => {
    setShowTrackVersionTooltip((prev) => !prev);
  };

  const onSubmit = async (
    values: any,
    {
      resetForm,
      setSubmitting,
    }: {
      resetForm: any;
      setSubmitting: any;
    }
  ) => {
    try {
      setSubmitting(true);
      const trackFile = new TrackFile();
      if (track) {
        trackFile.setTrackId(track.getId()!);
        trackFile.setTrackIdsList([track.getId()!]);
      } else {
        const matchingTrackIds: string[] = selectedTracksList.map(
          (selectedTrackName) => {
            const matchingTrack = allTracksList.find(
              (track) => track.getTitle() === selectedTrackName
            );
            return matchingTrack ? matchingTrack.getId() : "";
          }
        );
        trackFile.setTrackId(matchingTrackIds[0]);
        trackFile.setTrackIdsList(matchingTrackIds);
      }
      const fileKey = await awaitableUploadToS3(
        userId,
        values.fileUpload,
        `project`,
        values.fileUpload!.type,
        awsAccessKeyId,
        awsSecretAccessKey,
        awsSessionToken,
        handleProgress
      );
      const fileUrl = ASSETS_URL + "/" + fileKey;
      trackFile.setLabel(fileLabel);
      trackFile.setFileUrl(fileUrl);
      trackFile.setOwnerId(userId);
      trackFile.setType(fileType);
      trackFile.setFilename(uploadedFile.name);
      trackFile.setFileState(FileState.FILE_STATE_ACTIVE);
      if (parentFolderId) trackFile.setFolderId(parentFolderId);
      // sets bpm
      const audioMetadata = new AudioMetadata();
      audioMetadata.setBpm(values.bpm);
      trackFile.setAudioMetadata(audioMetadata);

      const invitedCollabList: InvitedCollaborator[] = [];
      // handling inviting collabs
      emailInviteList.forEach((email) => {
        const newInvitedCollab = new InvitedCollaborator();
        newInvitedCollab.setEmail(email);
        newInvitedCollab.setInvitedCollaboratorState(
          InvitedCollaboratorState.INVITED_COLLABORATOR_STATE_PENDING
        );
        invitedCollabList.push(newInvitedCollab);
      });
      try {
        await sendInvites(
          await getValidAccessToken(),
          emailInviteList,
          addedCollabIds,
          userId,
          `${window.location.origin}/my-files`,
          uploadedFile.name,
          InviteTemplate.INVITE_TEMPLATE_COLLABORATE_FILE
        );
      } catch (error) {
        console.log(error);
      }

      trackFile.setCollaboratorsList(collaborators);
      trackFile.setInvitedCollaboratorsList([...invitedCollabList]);
      const postTrackFileResponse = await postTrackFile(
        trackFile,
        await getValidAccessToken()
      );
      if (postTrackFileResponse instanceof RpcError) {
        throw postTrackFileResponse;
      }
      Mixpanel.track("add_track_file_success", {
        file_type: trackFile.getType(),
      });

      setSubmitting(false);
      setCollaborators([]);
      setEmailInviteList([]);
      handleClose(true, "New File added!");
      if (handleFileAdded) handleFileAdded();
    } catch (error) {
      console.log(error);
      alert(error);
      setSubmitting(false);
    }
  };

  const addCollaborator = (newCollaborator: string) => {
    if (newCollaborator) {
      if (
        collaborators.find(
          (collaborator) => collaborator.getUsername() === newCollaborator
        ) === undefined &&
        usersList.some((user) => user.getUsername() === newCollaborator)
      ) {
        const addedCollab = usersList.find(
          (user) => user.getUsername() === newCollaborator
        );

        if (addedCollab) {
          const newCollab = new Collaborator();
          newCollab.setUserId(addedCollab?.getUserId());
          newCollab.setUsername(addedCollab?.getUsername());
          const updatedCollaborators = [...collaborators, newCollab];

          setAddedCollabIds([...addedCollabIds, addedCollab.getUserId()]);
          setCollaborators(updatedCollaborators);
        }

        const newUserList = usersList.filter(
          (user) => user.getUsername() !== newCollaborator
        );
        setUsersList([...newUserList]);
        setCollabVal("");
      } else {
        toast.info("Username does not exist");
      }
      return true;
    }
  };

  const removeCollaborator = (collaborator: Collaborator) => {
    const updatedCollaborators = collaborators.filter(
      (item) => item !== collaborator
    );
    setCollaborators(updatedCollaborators);

    // updating userIds list that is being passed in sendInvite
    const updatedUserIdList = addedCollabIds.filter(
      (item) => item !== collaborator.getUserId()
    );
    setAddedCollabIds([...updatedUserIdList]);

    const newUser = new User();
    newUser.setUsername(collaborator.getUsername());
    newUser.setUserId(collaborator.getUserId());

    const newUsersList = [...usersList, newUser];
    setUsersList([...newUsersList]);
  };

  const handleCollabInvites = (event: React.SyntheticEvent<Element, Event>) => {
    if (emailInvite) {
      if (emailInvite.match(emailRegex)) {
        setEmailInviteList([...emailInviteList, emailInvite]);
        setEmailInvite("");
      } else {
        toast.info("Invalid email address!");
      }
    }
  };

  const handleRemoveEmail = (email: string) => {
    const updateEmailList = emailInviteList.filter((item) => item !== email);
    setEmailInviteList(updateEmailList);
  };
  const handleShowCollabTooltip = () => {
    setShowCollabTooltip((prev) => !prev);
  };

  const handleChangeTracksList = (
    _event: React.SyntheticEvent<Element, Event>,
    value: unknown
  ) => {
    const values = value as string[];
    const selectedTracksList = [...values];
    setSelectedTracksList(selectedTracksList);
  };

  return (
    <ContainerModal
      open={open}
      onClose={() => handleClose(false)}
      style={{ overflow: "auto" }}
    >
      <Box
        style={{ backgroundColor: APP_BACKGROUND_COLOR, color: TEXT_COLOR }}
        className="form-container"
      >
        <Box style={styles.modalHeaderContainer}>
          <span style={styles.modalHeader}>Add a New File to This Track</span>
          <IconButton onClick={() => handleClose(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <hr style={{ marginBottom: 30 }} />
        <Formik
          initialValues={newAddTrack}
          onSubmit={onSubmit}
          validationSchema={TRACK_VALIDATION_SCHEMA}
        >
          {({
            isSubmitting,
            setFieldValue,
            errors,
            handleBlur,
            handleChange,
            setFieldError,
            values,
          }) => (
            <Form>
              <Box style={{ color: TEXT_COLOR }} className="form-content">
                <label
                  style={{ color: errors.fileUpload ? "red" : TEXT_COLOR }}
                  className="uploadLabel"
                >
                  Upload File
                  <span className="asterisk">*</span>
                </label>
                <Files
                  className="image-upload"
                  style={{
                    ...styles.file,
                    ...{ borderColor: errors.fileUpload ? "red" : TEXT_COLOR },
                  }}
                  onChange={(newFiles: any[]) =>
                    handleAddFileToUpload(newFiles, setFieldValue)
                  }
                  multiple={false}
                  minFileSize={0}
                  clickable
                >
                  <FileUploadIcon
                    sx={{ width: "25px", height: "25px", marginRight: 2 }}
                  />
                  Drop a file here or click to upload
                </Files>
                {uploadedFile && (
                  <Box style={styles.uploadFileContainer}>
                    <Box style={styles.extensionContainer}>
                      {uploadedFile.extension}
                    </Box>
                    <Box style={styles.extensionNameContainer}>
                      <Box>{uploadedFile.name}</Box>
                      <Box>{uploadedFile.sizeReadable}</Box>
                    </Box>
                    <IconButton
                      onClick={() => {
                        setUploadedFile(undefined);
                        setFieldValue("fileUpload", undefined);
                        setFileType(TrackFileType.TRACK_FILE_TYPE_UNSPECIFIED);
                        setIsStem(false);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                )}
                <p className="input-description"></p>
                <Box className="input">
                  <label style={{ color: TEXT_COLOR }} htmlFor="label">
                    File Label{" "}
                    <span className="optional-input">(optional)</span>
                    <Box
                      style={{ display: "inline" }}
                      onMouseOver={() => setShowTrackVersionTooltip(true)}
                      onMouseLeave={() => setShowTrackVersionTooltip(false)}
                    >
                      <LightTooltip
                        title="File label uniquely identifies this uploaded file of your track"
                        placement="top"
                        open={showTrackVersionTooltip}
                        onClick={handleShowVersionTooltip}
                      >
                        <IconButton disableRipple>
                          <HelpOutlineIcon
                            color="info"
                            style={{ height: 16, width: 16 }}
                          />
                        </IconButton>
                      </LightTooltip>
                    </Box>
                  </label>
                  <input
                    style={styles.fileLabel}
                    type="text"
                    name="label"
                    id="label"
                    placeholder="Add a label for this file for the track"
                    value={fileLabel}
                    onChange={(event) => {
                      setFieldValue("fileLabel", event.target.value);
                      setfileLabel(event.target.value);
                    }}
                    disabled={isSubmitting}
                  />
                </Box>
                <Box className="input">
                  <label style={{ color: TEXT_COLOR }} htmlFor="fileType">
                    File Type <span className="optional-input">(optional)</span>
                  </label>
                  <Select
                    value={fileType}
                    onChange={handleChangeFileType}
                    fullWidth
                    sx={styles.selectFieldStyle}
                  >
                    {fileTypes.map((el) => {
                      return (
                        <MenuItem
                          disabled={el.option === "Specify the file type"}
                          key={el.option}
                          value={el.value}
                          sx={{ backgroundColor: "inherit" }}
                        >
                          {svgMap[el.option]}&nbsp;&nbsp;{el.option}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Box>
                {!track && (
                  <Box sx={{ marginBottom: "10px" }}>
                    <Typography>
                      Link Track
                      <LightTooltip
                        title="Link file with Track"
                        placement="top"
                      >
                        <IconButton disableRipple>
                          <HelpOutlineIcon
                            color="info"
                            style={{ height: 16, width: 16 }}
                          />
                        </IconButton>
                      </LightTooltip>
                    </Typography>
                    <FormControl fullWidth sx={{ borderColor: "white" }}>
                      <InputLabel sx={{ fontFamily: "Argumentum" }}>
                        {selectedTracksList.length > 0 ? "" : "Tracks"}
                      </InputLabel>
                      <SelectField
                        multiple
                        fullWidth
                        options={allTracksList.map((track) => track.getTitle())}
                        disableCloseOnSelect
                        value={selectedTracksList}
                        onChange={handleChangeTracksList}
                        renderOption={(props, option, { selected }) => (
                          <li {...props} style={{ fontFamily: "Argumentum" }}>
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option}
                            </>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            style={{ width: "100%" }}
                            {...params}
                            label={""}
                            InputLabelProps={{ shrink: false }}
                            classes={{ root: classes.customTextField }}
                          />
                        )}
                      />
                    </FormControl>
                  </Box>
                )}
                {isStem && (
                  <Box className="input">
                    <label htmlFor="bpm" style={styles.modalBpmLabel}>
                      {" "}
                      BPM <span className="optional-input">(optional)</span>
                      <Box
                        style={{ display: "inline" }}
                        onMouseOver={() => setShowBpmTooltip(true)}
                        onMouseLeave={() => setShowBpmTooltip(false)}
                      >
                        <LightTooltip
                          title="Beats per minute (will be detected automatically)"
                          placement="top"
                          open={showBpmTooltip}
                          onClick={handleshowBpmTooltip}
                        >
                          <IconButton disableRipple>
                            <HelpOutlineIcon
                              color="info"
                              style={{ height: 16, width: 16 }}
                            />
                          </IconButton>
                        </LightTooltip>
                      </Box>
                    </label>
                    {!bpmLoading && (
                      <Box style={{ display: "flex", flexDirection: "row" }}>
                        <input
                          style={addTrackFileModalStyles.bpmInput}
                          type="number"
                          name="bpm"
                          id="bpm"
                          min="0"
                          max="200"
                          step="1"
                          placeholder="BPM range 0-200"
                          value={values.bpm}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting}
                        />
                      </Box>
                    )}
                    {bpmLoading && (
                      <Box sx={styles.progressContainer}>
                        <LinearProgress color="inherit" />
                      </Box>
                    )}
                  </Box>
                )}

                {/* Collabs */}
                <Box className="collab-label">
                  <span>Add Collaborators </span>
                  <span className="optional-input">(optional)</span>
                  <Box
                    style={{ display: "inline" }}
                    onMouseOver={() => setShowCollabTooltip(true)}
                    onMouseLeave={() => setShowCollabTooltip(false)}
                  >
                    <LightTooltip
                      title="You can add artists, composers, and more collaborators"
                      placement="top"
                      open={showCollabTooltip}
                      onClick={handleShowCollabTooltip}
                    >
                      <IconButton disableRipple>
                        <HelpOutlineIcon
                          color="info"
                          style={{ height: 16, width: 16 }}
                        />
                      </IconButton>
                    </LightTooltip>
                  </Box>
                </Box>
                <hr />

                <Box sx={addTrackFileModalStyles.collaboratorContainer}>
                  <Box sx={{ width: "80%" }}>
                    <label
                      htmlFor="newCollaboratorUser"
                      style={styles.modalCreatorUsername}
                    >
                      {"Creator's Username"}
                    </label>
                    <UsernameSelectField
                      freeSolo
                      forcePopupIcon={false}
                      isOptionEqualToValue={(option, value) => option === value}
                      inputValue={collabVal}
                      onInputChange={(
                        event: React.SyntheticEvent<Element, Event>,
                        value: string
                      ) => {
                        setCollabVal(value);
                      }}
                      options={usersList
                        .map((item) => item.getUsername())
                        .sort()}
                      renderInput={(params) => (
                        <TextField
                          style={{
                            backgroundColor: APP_BACKGROUND_COLOR,
                            color: TEXT_COLOR,
                          }}
                          {...params}
                          label=" "
                          InputLabelProps={{ shrink: false }}
                          classes={{ root: classes.customTextField }}
                        />
                      )}
                      renderOption={(props, option: any) => (
                        <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                          {option}
                        </li>
                      )}
                    />
                  </Box>
                  <Button
                    disabled={collabVal === ""}
                    sx={addTrackFileModalStyles.collaboratorAddButton}
                    size="small"
                    variant="contained"
                    onClick={() => {
                      if (!isSubmitting) {
                        addCollaborator(collabVal);
                      }
                    }}
                  >
                    Add
                  </Button>
                </Box>
                <Box
                  className="collaborators"
                  style={{ margin: "20px 0 40px" }}
                >
                  <Box className="collaborators-target">
                    {collaborators &&
                      collaborators.length > 0 &&
                      collaborators.map((collaborator, index) => (
                        <Box className="collaborator" key={index}>
                          <p style={{ fontFamily: FONT_FAMILY, flexGrow: 1 }}>
                            {collaborator.getUsername()}
                          </p>
                          {!isSubmitting && (
                            <IconButton
                              onClick={() => removeCollaborator(collaborator)}
                            >
                              <DeleteForeverIcon />
                            </IconButton>
                          )}
                        </Box>
                      ))}
                  </Box>
                </Box>

                <div style={addTrackFileModalStyles.horizontalDiv} />
                <Box sx={addTrackFileModalStyles.emailInviteContainer}>
                  <Box sx={{ width: "80%" }}>
                    <label
                      htmlFor="emailInvite"
                      style={styles.modalCreatorUsername}
                    >
                      {"Invite Collaborator"}
                    </label>
                    <EmailInviteTextField
                      hiddenLabel
                      variant="outlined"
                      classes={{ root: classes.customTextField }}
                      placeholder="Send an invite email to a collaborator"
                      value={emailInvite}
                      onChange={(
                        event: React.ChangeEvent<
                          HTMLTextAreaElement | HTMLInputElement
                        >
                      ) => setEmailInvite(event.target.value)}
                    />
                  </Box>
                  <Button
                    disabled={emailInvite === ""}
                    sx={addTrackFileModalStyles.emailInviteAddButton}
                    size="small"
                    variant="contained"
                    onClick={handleCollabInvites}
                  >
                    Add
                  </Button>
                </Box>

                <Box style={{ marginBottom: 10, width: "100%" }}>
                  <Box>
                    {emailInviteList &&
                      emailInviteList.length > 0 &&
                      emailInviteList.map((email, index) => (
                        <Box
                          className="collaborator"
                          style={{ width: "100%" }}
                          key={index}
                        >
                          <p style={{ fontFamily: FONT_FAMILY, flexGrow: 1 }}>
                            {email}
                          </p>

                          <IconButton onClick={() => handleRemoveEmail(email)}>
                            <DeleteForeverIcon />
                          </IconButton>
                        </Box>
                      ))}
                  </Box>
                </Box>

                <hr />

                <Button
                  disabled={isSubmitting}
                  fullWidth
                  type="submit"
                  sx={styles.modalSubmitButton}
                  size="small"
                  variant="contained"
                >
                  {isSubmitting ? (
                    <>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        color="black"
                      />{" "}
                      <span style={styles.AddTrackTextContainer}>
                        {"Adding Track File..."}
                      </span>
                    </>
                  ) : (
                    <Typography variant="h1" sx={styles.modalSubmitButtonText}>
                      {"Add Track File"}
                    </Typography>
                  )}
                </Button>
                {isSubmitting && <CustomLinearProgress value={progress} />}
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </ContainerModal>
  );
};

export default AddTrackFileModal;
